import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Typography } from "@mui/material";
// import noCampaignImage from "../../src/Images/amico.svg";
import noCampaignImage from "../../src/Images/ImageToStl.com_amico.avif";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Tooltip } from "@mui/material";

import {
  CampaignClickedSvgIcon,
  CampaignOpenedSvgIcon,
  CampaignRepliedSvgIcon,
  CampaignSentSvgIcon,
  SearchSvgIcon,
} from "../CommonSvgs";

const headCells = [
  {
    id: "name",
    label: "Campaign name",
  },
  {
    id: "calories",
    label: "Sent",
  },
  {
    id: "fat",
    label: "Opened",
  },
  {
    id: "carbs",
    label: "Clicked",
  },
  {
    id: "protein",
    label: "Replied",
  },
  {
    id: "energy",
    label: "Goals",
  },
  {
    id: "actions",
    label: "Action",
  },
];

const Goals = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [campaignsData, setCampaignsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const [filterValue, setFilterValue] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-campaign-for-goal/${
          userDetails && userDetails.details._id
        }/${page + 1}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setIsLoading(false);
          setCampaignsData(response.data.details);
        } else {
          setIsLoading(false);
          setCampaignsData([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }, []);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - campaignsData.length) : 0;

  function timeAgo(timestamp) {
    if (campaignsData.length > 0) {
      const now = new Date();
      const time = new Date(timestamp);
      const seconds = Math.floor((now - time) / 1000);

      const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1,
      };

      for (const interval in intervals) {
        const value = Math.floor(seconds / intervals[interval]);
        if (value >= 1) {
          return `${value} ${interval}${value === 1 ? "" : "s"} ago`;
        }
      }
      return "just now";
    }
  }

  function formatTimestamp(timestamp) {
    if (campaignsData.length > 0) {
      const date = new Date(timestamp);
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
        date
      );
      return formattedDate.replace(/,/g, ""); // Remove the comma after the day
      // If you want to remove seconds as well, add the following line:
      // return formattedDate.replace(/,/g, '').replace(/:\d{2} /, ' ');
    }
  }

  const handleOnchange = (event) => {
    setFilterValue(event.target.value);
  };

  const filteredCampaigns = useMemo(() => {
    return campaignsData.filter((campaign) => {
      // Customize the condition based on your needs
      return campaign.campaign.Name.toLowerCase().includes(
        filterValue.toLowerCase()
      );
    });
  }, [campaignsData, filterValue]);

  const calenderSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66406 1.66797V4.16797"
        stroke="#868686"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3359 1.66797V4.16797"
        stroke="#868686"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.91406 7.57422H17.0807"
        stroke="#868686"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 7.08464V14.168C17.5 16.668 16.25 18.3346 13.3333 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V7.08464C2.5 4.58464 3.75 2.91797 6.66667 2.91797H13.3333C16.25 2.91797 17.5 4.58464 17.5 7.08464Z"
        stroke="#868686"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99803 11.4167H10.0055"
        stroke="#868686"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91209 11.4167H6.91957"
        stroke="#868686"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91209 13.9167H6.91957"
        stroke="#868686"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );

  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              borderBottom: "1px solid #DDD",
              padding: "6px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              disableRipple
              disableElevation
              sx={{
                cursor: "default",
                outline: "none !important",
                borderBottom: "2px solid #1C485F",
                borderRadius: 0,
                color: "#1C485F",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Typography
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 700,
                  fontFamily: "Source Sans 3",
                }}
                component="h2"
              >
                All Campaigns
              </Typography>
            </Button>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                backgroundColor: "#FAFAFA",
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #1c485f",
              }}
            >
              <SearchSvgIcon />
              <input
                value={filterValue}
                onChange={handleOnchange}
                type="text"
                style={{
                  outline: "none",
                  backgroundColor: "transparent",
                  padding: "0px 12px",
                }}
                placeholder="Search.."
              />
            </Box>
          </Box>
          {/* <GoalContacts /> */}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              {isLoading ? (
                // this body for display loading
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : filteredCampaigns.length > 0 ? (
                <>
                  {/* table header */}
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                    >
                      {headCells.map((headCell) => (
                        <TableCell key={headCell.id} align="left">
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            fontSize={"13px"}
                          >
                            {headCell.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* // this body is for displaying data */}
                  <TableBody>
                    {filteredCampaigns
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#FFF" : "#FAFAFA",
                          }}
                        >
                          <TableCell align="left">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "15px",
                                  fontStyle: "normal",
                                  fontWeight: 700,
                                  color: "#1C485F",
                                }}
                              >
                                {row.campaign.Name}
                              </p>
                              <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  color: "#868686",
                                }}
                              >
                                {timeAgo(new Date(row.campaign.createdAt))}
                              </p>
                              {/* <p
                                style={{
                                  marginTop: "0px",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  color: "#868686",
                                }}
                              >
                                Sent from: {row.campaign.FromEmail[0]?.FromEmail}
                              </p> */}
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  marginTop: "0px",
                                }}
                              >
                                {calenderSvg}
                                <span
                                  style={{
                                    fontFamily: "Source Sans 3",
                                    fontSize: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    color: "#868686",
                                  }}
                                >
                                  {formatTimestamp(
                                    row.campaign.Duration.StartDate
                                  )}
                                </span>
                              </p>
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignSentSvgIcon />
                              {row.sentCount}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignOpenedSvgIcon />
                              {row.openedCount}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignClickedSvgIcon />
                              {row.clickedCount}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <CampaignRepliedSvgIcon />
                              {row.repliedCount}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            {row.goalCount}
                          </TableCell>
                          <TableCell align="left">
                            <button
                              style={{
                                fontSize: "12px",
                                color: "#868686",
                                fontWeight: 400,
                                fontFamily: "Source Sans 3",
                                fontStyle: "normal",
                                outline: "none",
                                padding: "6px 10px",
                                border: "1px solid #868686",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                              onClick={() => {
                                history.push(`/Goals/${row.campaign._id}`);
                              }}
                            >
                              <Tooltip title="Open goal list" arrow style={{display: "flex",
                                alignItems: "center",
                                gap: "4px",}}>
                                  
                              <VisibilityIcon />
                                   
                              View
                              </Tooltip>
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                // this body for displaying empty data
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={noCampaignImage}
                          alt="Nothing found"
                          style={{ height: "250px" }}
                        />
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            color: "#393939",
                          }}
                        >
                          No data found
                        </p>
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            color: "#868686",
                            marginTop: "0px",
                          }}
                        >
                          {filterValue.length === 0
                            ? "Oops! You don’t have any campaigns yet!"
                            : `There's no campaign that fits your search`}
                        </p>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={headCells.length} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : filteredCampaigns.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={campaignsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
    </div>
  );
};

export default Goals;
